import { createSlice } from "@reduxjs/toolkit";
import {
  addCharger,
  editCharger,
  getChargerKPI,
  getChargers,
  retireCharger,
  unretireCharger,
} from "../APIs/chargersAPI";

const initialState = {
  loading: false,
  error: {},
  status: "idle",
  chargerList: {
    result: [],
    totalRecords: 0,
  },
  currentCharger: {},
  deleteChargerModal: {
    visible: false,
    charger: {},
  },
  showToastMessage: {
    visible: false,
    data: {},
  },

  threeDotsPopoverId: 0,

  retireChargerModal: {
    visible: false,
    id: 0,
    serialNo: "",
  },

  unretireChargerModal: {
    visible: false,
    id: 0,
    serialNo: "",
  },

  kpi: {
    total: 0,
    active: 0,
    service: 0,
  },
};

export const chargersSlice = createSlice({
  name: "chargers",
  initialState,
  reducers: {
    updateCharger: (state, action) => {
      state[action.payload.key] = action.payload.value;
    },
  },
  extraReducers(builder) {
    // add charger
    builder.addCase(addCharger.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCharger.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(addCharger.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get charger
    builder.addCase(getChargers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getChargers.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.chargerList = action.payload;
    });
    builder.addCase(getChargers.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // edit charger
    builder.addCase(editCharger.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editCharger.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(editCharger.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // retire charger
    builder.addCase(retireCharger.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(retireCharger.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(retireCharger.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // un-retire charger
    builder.addCase(unretireCharger.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(unretireCharger.fulfilled, (state) => {
      state.loading = false;
      state.status = "fulfilled";
    });
    builder.addCase(unretireCharger.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });

    // get charger kpi
    builder.addCase(getChargerKPI.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getChargerKPI.fulfilled, (state, action) => {
      state.loading = false;
      state.status = "fulfilled";
      state.kpi = action.payload.kpi;
    });
    builder.addCase(getChargerKPI.rejected, (state, action) => {
      state.loading = false;
      state.status = "rejected";
      state.error = action.error;
    });
  },
});

export const { updateCharger } = chargersSlice.actions;

export default chargersSlice.reducer;
